<template>
  <!-- <v-app id="inspire" class="bg-light">
    <router-view :key="$route.fullPath"></router-view>
  </v-app> -->

  <br/>
</template>
<script>
  location.href = location.href
  .replace("/session/login", "/auth/login")
    .replace("localhost:8080", "miportal.tuprontomx.com")
    .replace("prontoapp.tech", "tuprontomx.com")

export default {
  name: 'app',
  methods: {}
}
</script>
